var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f1jp72esea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v1295H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "une7m10e7b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0c.213 0 .405.119.489.303L6.63 2.812l2.886.246a.525.525 0 0 1 .458.343.48.48 0 0 1-.156.53L7.636 5.729 8.28 8.39a.485.485 0 0 1-.207.515.558.558 0 0 1-.584.024L5 7.53 2.51 8.93a.555.555 0 0 1-.583-.024.484.484 0 0 1-.207-.515l.643-2.662L.182 3.931a.48.48 0 0 1-.156-.53.526.526 0 0 1 .457-.343l2.887-.246L4.511.303A.533.533 0 0 1 5 0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xuimleeuyc",
    x1: 12.119,
    y1: 4.5,
    x2: 0,
    y2: 4.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAB06E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#804900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f1jp72esea)",
    transform: "translate(-944 -116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#une7m10e7b)",
    transform: "translate(944 116)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#xuimleeuyc)",
    d: "M0 0h10v9H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.e084b71e91f9046bda666d2e2e67ccec.svg";
export { ForwardRef as ReactComponent };